import { API_ROOT } from '../constants'
import api from '../utils/api'

/**
 * Get HMAC-SHA256 signature for Crisp chat email verification
 * @param {string} email - User email to sign
 * @returns {Promise} - Promise resolving to signature data
 */
export const getChatSignature = async (email) => {
  try {
    const response = await api.get(`${API_ROOT}/v3/support/chat-signature`, { email })
    return response.data
  } catch (error) {
    console.error('Failed to get chat signature:', error)
    throw error
  }
}
